import axios from 'axios'
import { BUSCAR_MAPA_ITINERARIO_IDA, BUSCAR_MAPA_ITINERARIO_VOLTA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarMapaVeiculoItinerario (codItinerario, codOrigem, codDestino, seIda, categoria) {
  const url = `${URL}/mapas-veiculos/itinerario/${codItinerario}/origem/${codOrigem}/destino/${codDestino}?categoria=${categoria}`;
  if (seIda) {
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
          type: BUSCAR_MAPA_ITINERARIO_IDA,
          payload: response

        })
    );
  }

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_MAPA_ITINERARIO_VOLTA,
        payload: response

      })
  );
}
